import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { useHistory, withRouter } from 'react-router'
import arrow from '../../assets/group-4.svg'
import call from '../../assets/phone-call-1.svg'
import AccuracyDifficulty from '../../components/AccuracyDifficulty/AccuracyDifficulty.js'
import OverAllAccuracy from '../../components/OverAllAccuracy/OverAllAccuracy.js'
import OverAllDifficulty from '../../components/OverAllDifficulty/OverAllDifficulty.js'
import OverAllScore from '../../components/OverAllScore/OverAllScore.js'
import { UPDATE_ACTIVE_SECTION } from '../../constants/actionTypes'
import './TestAnalytics.css'

const mapStateToProps = (state) => ({
    queryparam: state.queryparam,
    testData: state.testpanel,
    analytics: state.analytics,
})

const mapDispatchToProps = (dispatch) => ({
    setActiveSection: (payload) =>
        dispatch({ type: UPDATE_ACTIVE_SECTION, payload }),
})

const graphWidth = 340

const TestAnalytics = (props) => {
    const history = useHistory()
    const handleSubmit = () => {
        sessionStorage.setItem('isSubmitted', true)
        history.push('/testpanel')
    }
    useEffect(() => {
        // The `active` value in App.js & active section in redux has to be set to 0 here.
        // Otherwise if the no. of total questions is less than the number of sections in the test and say the user was
        // on the last question then the app will break in `questions[props.active_section]` in src/views/TestPanel/helper.js
        props.setActive(0)
        props.setActiveSection(0)
    }, [])
    return (
        <div className="analytics">
            <div style={{ height: '100%', justifyContent: 'center' }}>
                <div className="cards-container">
                    <OverAllScore
                        width={graphWidth}
                        data={{ analytics: props.analytics }}
                    />
                    <OverAllAccuracy
                        width={graphWidth}
                        data={{ analytics: props.analytics }}
                    />
                    <OverAllDifficulty
                        width={graphWidth}
                        data={{ analytics: props.analytics }}
                    />
                    <AccuracyDifficulty
                        width={graphWidth}
                        data={{ analytics: props.analytics }}
                    />
                    {/* <TestTaken/>
        <OverAllDifficulty data={props} />
          <AccuracyDifficulty data={props} />
          <OverAllDifficulty data={props} />
          <AccuracyDifficulty data={props} /> */}
                </div>
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: '#f5f7fa',
                    }}
                >
                    <button
                        className="click-us-analytics-btn"
                        onClick={handleSubmit}
                    >
                        Click here to see your Answer Key
                        <img style={{ marginLeft: '3%' }} src={arrow} />
                    </button>
                </div>
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: '#f5f7fa',
                        padding: '30px 0px',
                    }}
                >
                    <div className="analytics-call-us">
                        <div className="analytics-insight-headers-content">
                            <div>
                                <p>Book Your Academic Counselling Session</p>
                            </div>
                            {/* <div className="line-book-us"></div> */}
                            <div className="call-us">
                                <b>
                                    <img style={{ height: '25px' }} src={call} />{' '}
                                    &nbsp;&nbsp;Call Us{' '}
                                </b>
                                <span style={{ color: '#6d7278' }}>
                                    We are available to assist you from 10 am to 6pm
                                    on all days.
                                </span>
                                {props.queryparam.branch_phone ? (
                                    <h3>{props.queryparam.branch_phone}</h3>
                                ) : null}
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    {/* <div className="analytics-insight-body">
          <div className="analytics-insight-sidenav">
            <span>Overall</span>
            <span>Chapters</span>
            <span>Difficulty Levels</span>
            <span>Answer Key</span>
          </div>
          <div className="analytics-insight-container">
            <div className="analytics-insight-major-insight">
              <span>Score</span>
              <span>Attempts</span>
              <span>Accuracy</span>
              <span>Time</span>
              <span>Time Taken</span>
            </div>
            <div className="analytics-insight-Chapters">
              <span>Work Energy and Power</span>
              <span>System of Particle and rotational motion</span>
              <span>Moving charges and magnetism</span>
              <Button style={{ width: "500px" }} name="View More Chapters" />
            </div>
          </div>
        </div> */}
                </div>
            </div>
        </div>
    )
}
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(TestAnalytics),
)
